import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios'; // Import axios
import { toast } from 'react-toastify';
import { Config } from '../.env.js';
import 'react-toastify/dist/ReactToastify.css';
import "../pages/style.css";

const ReviewerSignIn = () => {
    const [Email, setEmail] = useState("");
    const [Password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    const navigate = useNavigate();
    const location = useLocation();
    const campaignName = location.state?.campaignName;

    const emailRegex = /^[a-zA-Z0-9._%+-]+@(?!(?:.*\.\.)|.*\.$)[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,}$/;
    const hasValEmail = emailRegex.test(Email);

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };
    const handlesignin = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            const res = await axios.post(`${Config.API_URL}/signIn`, {
                email: Email,
                password: Password,
            });

            // Check for errors in response
            if (res.data.error) {
                toast.error(res.data.error);
                setErrorMessage(res.data.error);
                setLoading(false);
                return;
            }

            // Destructure and save user data and token
            const { token, user } = res.data;

            if (token && user) {
                localStorage.setItem("authToken", token);
                localStorage.setItem("loggedInUserName", user.name);
                localStorage.setItem("loggedInUserId", user._id);
                localStorage.setItem("isSignedUp", "true");
                localStorage.setItem("isloggedIn", "true");
                setTimeout(() => {
                    navigate("/live-user");
                }, 1000);
            } else {
                toast.error("Unexpected server response.");
            }
        } catch (error) {
            console.error("Error during login:", error);
            toast.error("Login failed. Please check your credentials.");
        } finally {
            setLoading(false);
        }
    };
    return (
        <div className='thank-you-container'>
            {loading && (
                <div className="loader-overlay">
                    <div className="loader"></div>
                </div>
            )}
            {errorMessage && (
                <div className="notification is-danger">
                    <p>{errorMessage}</p>
                </div>
            )}
            <div className='control my-input' style={{ marginLeft: "27rem" }}>

                <h1 className='title mt-5 has-text-white'>Sign In to Participate in campaign</h1>
                <form>
                    <div className='my-2 has-text-left my-input'>
                        <label className='label has-text-white'>Your Email Registered With hobo</label>
                    </div>
                    <div className='field'>
                        <div className='control has-icons-left my-input'>
                            <input
                                className='input is-rounded'
                                type='text'
                                placeholder='Email ID'
                                value={Email}
                                onChange={(e) => setEmail(e.target.value)}
                            />
                            {Email && !hasValEmail && (
                                <small className={`ml-1  ${!hasValEmail && Email !== '' ? 'has-text-danger' : 'has-text-success'}`}>
                                    {!hasValEmail && Email !== '' ? 'Enter a valid email address' : ''}
                                </small>
                            )}

                            <span className="icon is-small is-left">
                                <i className="fas fa-envelope"></i>
                            </span>
                        </div>
                    </div>
                    <div className='my-2 has-text-left my-input'>
                        <label className='label has-text-white'>Password</label>
                    </div>
                    <div className='field'>
                        <div className="control has-icons-left has-icons-right is-flex my-input">
                            <input
                                className="input is-rounded"
                                type={showPassword ? 'text' : 'password'}
                                placeholder="Password"
                                value={Password}
                                onChange={(e) => setPassword(e.target.value)}
                            />
                            <span className="icon is-small is-left">
                                <i className="fas fa-key"></i>
                            </span>
                            <span className="icon is-small is-right" onClick={togglePasswordVisibility} style={{ cursor: 'pointer', 'pointer-events': 'all' }}>
                                <i className={`fas fa-eye${showPassword ? '-slash' : ''}`}></i>
                            </span>
                        </div>
                    </div>
                    <div className='Link mb-3'>
                        <Link to='/forgot-review'>
                            <p className='has-text-right my-input'>Forgot Your Password?</p>
                        </Link>
                    </div>
                    <div className='field'>
                        <div className='control my-input'>
                            <button
                                className='button is-primary is-rounded is-focused is-medium is-fullwidth'
                                disabled={!Email || !Password || loading}
                                type='submit'
                                onClick={handlesignin}
                            >
                                {loading ? (
                                    <div className="loader"></div> // Loader
                                ) : (
                                    'SIGN IN'
                                )}
                            </button>
                        </div>
                    </div>
                </form>
                <div className='is-flex has-text-left mr-5 mt-3 my-input'>
                    <p className="has-text-white">Don't have an account?</p>
                    <Link to='/user'>
                        <span className='has-text-weight-bold ml-2'>Sign Up</span>
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default ReviewerSignIn;
